import { render } from "./ActionModal.vue?vue&type=template&id=28a0115d&ts=true"
import script from "./ActionModal.vue?vue&type=script&lang=ts"
export * from "./ActionModal.vue?vue&type=script&lang=ts"

import "./ActionModal.vue?vue&type=style&index=0&id=28a0115d&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__